import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table, Tag } from "antd";
import tagByStatus from "features/requestApproval/components/TagByStatus";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";

const RedeemTimeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false,
  isHistory = false
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }
  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|REDEEM_TIME")) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|REDEEM_TIME")) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if (roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST")) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }

  console.log("redeem ", dataSource);
  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      sorter: true,
    },
    {
      title: <div className="text-table">{t('redeem_time.label.date_to_redeem')}</div>,
      dataIndex: "redeemDate",
      key: "redeemDate",
      sorter: true,
      width: 170,
      render: (_, record) => {
        return record?.redeemDate ? formatDate(record?.redeemDate) : "-"
      }
    },
    {
      title: <div className="text-table">{t('endorsement.label.start_time')}</div>,
      dataIndex: "startTime",
      key: "startTime",
    },
    {
      title: <div className="text-table">{t('endorsement.label.end_time')}</div>,
      dataIndex: "endTime",
      key: "endTime",
    },
    {
      title: <div className="text-table">{t('endorsement.label.total_duration')}</div>,
      dataIndex: "totalDuration",
      key: "totalDuration",
    },
    {
      title: <div className="text-table">{t('endorsement.label.description')}</div>,
      dataIndex: "description",
      key: "description",
    },
    {
      title: <div className="text-table">{t('endorsement.label.status')}</div>,
      dataIndex: "status",
      key: "status",
      sorter: true,
      align: "center",
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|REDEEM_TIME") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|REDEEM_TIME")) ? actionBar() : {}
  ];

  function actionBar() {
    if (!isEmployee) {
      return {
        title: <div className="text-table">{t('action.action')}</div>,
        key: "action",
        align: "center",
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: readMode(_.approveStatusEn, record)
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      }
    } else {
      return {}
    }
  }

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default RedeemTimeTable;
